import moment from "moment";
import { PagePaths } from "@/partner/shared/constants/routes";

/** Analytics tab that a stat column of the links table opens. */
export type LinkAnalyticsTab = "views" | "sales" | "users";

/**
 * Analytics tab filtered by the link. Link stats are all-time, so the period
 * starts on the day the link was created (analytics always has a period, the
 * default one is the last month); the end is the analytics default (today).
 */
export function linkAnalyticsUrl(
  tab: LinkAnalyticsTab,
  linkId: string,
  createdAt: string
): string {
  const params = [`filter[linkIds][]=${encodeURIComponent(linkId)}`];
  const from = moment(createdAt);
  if (from.isValid()) {
    params.push(
      `filter[dateFrom]=${encodeURIComponent(from.startOf("day").format())}`
    );
  }
  return `${PagePaths.analytics}/${tab}?${params.join("&")}`;
}
